// ======================================================================
// File Name       : DistributionAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import { decamelizeKeys, camelizeKeys } from 'humps';
import _ from 'lodash';
import moment from 'moment';
import store from '../../store';
import { commonCallApi } from '../../utils/ApiUtils';
import * as actionTypes from '../../constants/actionTypes/report';
import * as ModalIds from '../../constants/ModalIds';
import { openModal } from './../ModalAction';
import * as groupRequests from './../httpRequests/group';
import { REPORT_STATUS, REPORT_STATUS_SUBMITTED } from '../../constants/KeyValueConstants';
import { SELECT_TARGET_DATA, SELECT_REPORT_RESPONSE_DATA } from '../../constants/index';
import * as actionCreators from '../actionCreators/report/distribution';
import { DATA_LIMIT_FLAG } from '../../constants/GroupConstants';
import { USER_CREATE_TYPE } from '../../constants/UserConstants';

export function searchDistributionReport() {
  return (dispatch, getState) => {
    const state = getState();
    const { form, distributionReport } = state;
    let searchForm = {};
    if (form.distributionReportSearchForm) {
      const { distributionReportSearchForm } = form;
      searchForm = distributionReportSearchForm.values;
    }
    const { distributionReportList } = distributionReport;
    const { searchInfo } = distributionReportList;
    const searchInfoData = {
      reportStatusList: [REPORT_STATUS_SUBMITTED],
      reportName: searchForm ? searchForm.reportName : undefined,
      includeDeadlineReportFlg: searchForm && searchForm.includeDeadlineReportFlg ? 1 : 0,
      reportHistorySortType:
      searchInfo.reportHistorySortType === null ? undefined : searchInfo.reportHistorySortType,
      ascendingDescendingSort: searchInfo.ascendingDescendingSort || 0,
      startPosition: searchInfo.startPosition || 0,
      returnMaxNum: searchInfo.returnMaxNum,
    };
    return dispatch(getDistributionReportCount(searchInfoData));
  };
}

export function getDistributionReport(itemReportIdAuto) {
  const param = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
    searchInfo: {
      itemReportIdAuto,
      reportStatusList: [REPORT_STATUS_SUBMITTED],
      noSetCheckerFlg: 1,
      includeDeadlineReportFlg: 1,
    },
  };
  return dispatch => commonCallApi({
    path: 'reportOperation/GetList',
    data: param,
  })
    .then((result) => {
      dispatch(actionCreators.receiveDistributionReportGet(result));
    });
}

export function getDistributionReportCount(searchInfo, isSearchReportFirst) {
  return (dispatch) => {
    const param = {
      selectReportResponseData: SELECT_REPORT_RESPONSE_DATA.ITEM_REPORT_LIST,
      searchInfo: {
        reportStatusList: searchInfo.reportStatusList,
        itemReportList: searchInfo.reportItemReportIdAutoList || [],
        includeDeadlineReportFlg: searchInfo.includeDeadlineReportFlg || 0,
        reportName: searchInfo.reportName || '',
        startPosition: searchInfo.startPosition || 0,
        returnMaxNum: searchInfo.returnMaxNum,
      },
    };
    return commonCallApi({
      path: 'reportOperation/Count',
      data: param,
    })
      .then((result) => {
        result.isSearchReportFirst = isSearchReportFirst;
        dispatch(actionCreators.receiveDistributionReportSearch(result));
      });
  };
}

export function getDistributionReportCheckingCount(searchInfo) {
  return (dispatch) => {
    const param = {
      selectReportResponseData: SELECT_REPORT_RESPONSE_DATA.CHECKER_USER_LIST,
      searchInfo: {
        reportStatusList: searchInfo.reportStatusList,
        checkerUserList: searchInfo.checkerUserList,
      },
    };
    commonCallApi({
      path: 'reportOperation/Count',
      data: param,
    })
      .then((result) => {
        dispatch(actionCreators.receiveDistributionReportCheckingCount(result));
      });
  };
}

export function openReportDialog(itemReportIdAuto) {
  return (dispatch, getState) => {
    dispatch(getDistributionReport(itemReportIdAuto)).then(() => {
      dispatch(actionCreators.receiveReportData(itemReportIdAuto));
      dispatch(openModal(ModalIds.ASSIGNMENT_DISTRIBUTION_REPORT));
    });
  };
}

export function searchUser() {
  return (dispatch, getState) => {
    const state = getState();
    const { form, distributionReport } = state;
    let searchForm = {};
    if (form.distributionReportUserSearchForm) {
      const { distributionReportUserSearchForm } = form;
      searchForm = distributionReportUserSearchForm.values;
    }
    const { distributionReportDetail } = distributionReport;
    const { searchInfo, correctorList, approverList, groupList } = distributionReportDetail;
    const seachInfoData = {
      managementAuthorityList: [...correctorList, ...approverList, ""], //STEP11.2.0: add empty string to search new admin ignore check management authority
      userName: searchForm ? searchForm.userName : undefined,
      userAttributeKeyNum: searchForm && !isNaN(searchForm.userAttributeKeyNum) ? parseInt(searchForm.userAttributeKeyNum, 10) : searchInfo.userAttributeKeyNum,
      userAttributeSearchText: searchForm ? searchForm.userAttributeSearchText : undefined,
      userSortType: searchInfo.userSortType === null ? undefined : searchInfo.userSortType,
      ascendingDescendingSort: searchInfo.ascendingDescendingSort || 0,
      startPosition: searchInfo.startPosition || 0,
      returnMaxNum: searchInfo.returnMaxNum,
    };

    // get group list
    if (searchInfo && searchInfo.selectedGroup && searchInfo.selectedGroup.groupSecernId) {
      const groupListRequest = [];
      groupListRequest.push(searchInfo.selectedGroup.groupSecernId);
      seachInfoData.groupSecernIdList = groupListRequest;
    }
    if (seachInfoData.userAttributeSearchText) {
      dispatch(getAttributeList(seachInfoData));
    } else {
      dispatch(getUser(seachInfoData));
    }
  };
}

export function getAttributeList(searchInfo = {}) {
  return (dispatch) => {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: {
        userAttributeType: 4, // type = 4 : user
        userAttributeKeyNum: searchInfo.userAttributeKeyNum,
        userAttributeSearchText: searchInfo.userAttributeSearchText,
      },
    };
    commonCallApi({
      path: 'userAttribute/GetList',
      data: param,
      institutionId: 1,
    }).then((result) => {
      const userSecernIdList = [];
      if (result && result.userAttributeList &&
        result.userAttributeList.length > 0) {
        for (const userAttribute of result.userAttributeList) {
          userSecernIdList.push(userAttribute.secernId);
        }
      }
      if (userSecernIdList && userSecernIdList.length) {
        dispatch(getUser(searchInfo, userSecernIdList));
      } else {
        const userResult = { recordNum: 0, userList: [] };
        dispatch(actionCreators.receiveUserListSearch(userResult));
      }
    });
  };
}

export function getUser(searchInfo, userSecernIdList) {
  return (dispatch) => {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: {
        managementAuthorityList: searchInfo.managementAuthorityList,
        userName: searchInfo.userName,
        groupList: searchInfo.groupSecernIdList,
        userSecernIdList,
        userSortType: searchInfo.userSortType,
        ascendingDescendingSort: searchInfo.ascendingDescendingSort,
        startPosition: searchInfo.startPosition,
        returnMaxNum: searchInfo.returnMaxNum,
        userCreateType: USER_CREATE_TYPE.DEFINED_AND_REPRESENTATIVE_USER,
      },
    };
    commonCallApi({
      path: 'user/GetList',
      data: param,
      institutionId: 1,
    }).then((userResult) => {
      dispatch(actionCreators.receiveUserListSearch(userResult));
      const checkerUserList = [];
      if (userResult && userResult.userList &&
        userResult.userList.length > 0) {
        userResult.userList.forEach((user) => {
          if (user.userSecernId) {
            checkerUserList.push(user.userSecernId);
          }
        });
      }
      if (checkerUserList && checkerUserList.length > 0) {
        searchInfo.reportStatusList = [REPORT_STATUS.REPORT_STATUS_CHECKING, REPORT_STATUS.REPORT_STATUS_REMAND];
        searchInfo.checkerUserList = checkerUserList;
        dispatch(getDistributionReportCheckingCount(searchInfo));
      }
    });
  };
}

export function setManagementAuthority(managementAuthorityList) {
  return (dispatch) => {
    dispatch(actionCreators.receiveManagementAuthorityList(managementAuthorityList));
  };
}

export function updateDistributionReportByCorrector(param = {}) {
  return (dispatch) => {
    commonCallApi({
      path: 'reportOperation/EditByCorrector',
      data: param,
      institutionId: 1,
    }).then((updateResult) => {
      dispatch(actionCreators.receiveDistributionReportUpdate(updateResult));
    });
  };
}

export function clearUpdateResult() {
  return (dispatch) => {
    dispatch(actionCreators.receiveResetReportUpdateResult());
  };
}

export function getGroupList() {
  return (dispatch) => {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      dataLimitFlag: DATA_LIMIT_FLAG.LIMIT,
    };
    commonCallApi({
      path: 'group/GetStructure',
      data: param,
      institutionId: 1,
    }).then((camelizeJson) => {
      dispatch(actionCreators.receiveGroupList(camelizeJson));
    });
  };
}

export function getAuthorityList() {
  return (dispatch) => {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
    };
    commonCallApi({
      path: 'userAuthority/GetList',
      data: param,
      institutionId: 1,
    }).then((camelizeJson) => {
      dispatch(actionCreators.receiveAuthorityList(camelizeJson));
      dispatch(searchUser());
    });
  };
}

export function resetDistributionReportAssignment() {
  return (dispatch) => {
    dispatch(actionCreators.receiveReportAssignmentResetInit());
  };
}

export function resetDistributionReport() {
  return (dispatch) => {
    dispatch(actionCreators.receiveReportResetInit());
  };
}

export function initDistributionReportList() {
  return dispatch => dispatch(searchDistributionReport());
}

export function initDistributionReportDetail() {
  return (dispatch, getState) => {
    dispatch(getGroupList());
    dispatch(getAuthorityList());
  };
}

export function updateDistributionReportSearchInfo(searchInfo) {
  return (dispatch) => {
    dispatch(actionCreators.receiveDistribtutionReportUpdateSearchInfo(searchInfo));
  };
}

export function updateDistributionReportDetailSearchInfo(searchInfo) {
  return (dispatch) => {
    dispatch(actionCreators.receiveDistribtutionReporDetailUpdateSearchInfo(searchInfo));
  };
}

export function updateDistributionReportDetailUserListInfo(userListInfo) {
  return (dispatch) => {
    dispatch(actionCreators.receiveUpdateUserListInfo(userListInfo));
  };
}
